export default {
  data() {
    return {
      possibleAggregations: [
        { text: 'Lukumäärä', value: 'count', type: 'number' },
        { text: '%', value: 'percentage', type: 'number' },
        { text: 'Keskiarvo', value: 'avg', type: 'number' },
        { text: 'Mediaani', value: 'median', type: 'number' },
        { text: 'Summa', value: 'sum', type: 'number' },
        { text: 'Maksimi', value: 'max', type: 'number' },
        { text: 'Minimi', value: 'min', type: 'number' },
      ],
      possibleColumns: [
        { text: 'Ulkopelijoukkue', value: 'fielding_team_id', type: 'number' },
        { text: 'Sisäpelijoukkue', value: 'hitting_team_id', type: 'number', final_type: 'string' },
        { text: 'Kotijoukkue', value: 'home_team_id', type: 'number', final_type: 'string' },
        { text: 'Vierasjoukkue', value: 'away_team_id', type: 'number', final_type: 'string' },
        { text: 'Tilanne', value: 'bases_state', type: 'string' },
        { text: 'Lyöjä', value: 'hitter_name', type: 'string' },
        { text: 'Kärkijetenijä', value: 'karkirunner_name', type: 'string' },
        // { text: 'Event ID', value: 'event_id', type: 'string' },
        { text: 'Laittoman jälkeinen turha', value: 'after_marked_laiton', type: 'boolean' },
        // { text: 'Away Hitter Num', value: 'away_hitter_num', type: 'number' },
        // { text: 'Bases First ID', value: 'bases.first.id', type: 'number' },
        // { text: 'Bases First Name', value: 'bases.first.name', type: 'string' },
        // { text: 'Bases Home ID', value: 'bases.home.id', type: 'number' },
        // { text: 'Bases Home Name', value: 'bases.home.name', type: 'string' },
        // { text: 'Bases Second ID', value: 'bases.second.id', type: 'number' },
        // { text: 'Bases Second Name', value: 'bases.second.name', type: 'string' },
        // { text: 'Bases Third ID', value: 'bases.third.id', type: 'null' },
        // { text: 'Bases Third Name', value: 'bases.third.name', type: 'null' },
        // { text: 'Base Changes First To Second', value: 'base_changes.first_to_second', type: 'null' },
        // { text: 'Base Changes Home To First', value: 'base_changes.home_to_first', type: 'null' },
        // { text: 'Base Changes Second To Third', value: 'base_changes.second_to_third', type: 'string' },
        // { text: 'Base Changes Third To Home', value: 'base_changes.third_to_home', type: 'null' },
        // { text: 'Date', value: 'date', type: 'number' },
        // { text: 'Endtime', value: 'endtime', type: 'number' },
        { text: 'Peli', value: 'game_id', type: 'string', final_type: 'string' },
        { text: 'Vuoropari', value: 'game_phase.inning', type: 'number' },
        { text: 'Jakso', value: 'game_phase.jakso', type: 'number' },
        { text: 'Tasoittava vuoro', value: 'game_phase.lopettava', type: 'boolean' },
        // { text: 'Hitter ID', value: 'hitter_id', type: 'number'possibleColumns },
        // { text: 'Hitter Number', value: 'hitter_number', type: 'number' },
        { text: 'Lyöntipuoli', value: 'hitter_side', type: 'string' },
        // { text: 'Hitting', value: 'hitting', type: 'string' },
        { text: 'Lyönnin suunta', value: 'hit_direction', type: 'string' },
        // { text: 'Hit Map Coordinates X', value: 'hit_map_coordinates.x', type: 'number' },
        // { text: 'Hit Map Coordinates Y', value: 'hit_map_coordinates.y', type: 'number' },
        { text: 'Lyönti nro.', value: 'hit_number', type: 'number' },
        { text: 'Tulos', value: 'hit_outcome', type: 'string' },
        { text: 'Lyönnin tyyppi', value: 'hit_type', type: 'string' },
        // { text: 'Home Hitter Num', value: 'home_hitter_num', type: 'number' },
        // { text: 'Joker Hitting', value: 'joker_hitting', type: 'boolean' },
        // { text: 'Kärkijuoksija ID', value: 'karkirunner_id', type: 'number' },
        { text: 'Stadion', value: 'stadion_id', type: 'number', final_type: 'string' },
        // { text: 'Lyöntivuoro', value: 'plate_appearance_id', type: 'string' },
        // { text: 'Syöttökartta X', value: 'pitch.wrong_map_coordinates.x', type: 'number' },
        // { text: 'Syöttökartta Y', value: 'pitch.wrong_map_coordinates.y', type: 'number' },
        // { text: 'Heitto tapahtui', value: 'play.has_play_time', type: 'boolean' },
        // { text: 'Jea', value: 'play.movement_distances.from_home_hit', type: 'number' },
        // { text: 'Lyönnin matka haltuunotosta', value: 'play.movement_distances.from_home_possession', type: 'number' },
        // { text: 'Heitto tapahtui', value: 'play.play_video_times.throw_goes', type: 'number' },
        // { text: 'Pallon haltuunotto', value: 'play.play_video_times.possession', type: 'number' },
        // { text: 'Juoksun ID', value: 'run.run_id', type: 'number' },
        // { text: 'Lähtöaika', value: 'run.run_times.lahto', type: 'number' },
        // { text: 'Etenijä pesässä', value: 'run.run_video_times.on_base', type: 'number' },
        { text: 'Up-suorituksen tulos', value: 'play.play_outcome', type: 'string' },
        { text: 'Kärkilyönnit', value: 'karkilyonnit', type: 'number' },
        // { text: 'Edellinen lyönti', value: 'previous_hit_id', type: 'string' },
        // { text: 'Heiton kovuus', value: 'play.throw_calculated_speed', type: 'number' },
        // { text: 'Lähtöaika', value: 'run.measured_from_hit', type: 'boolean' },
        // { text: 'Pelin mittaus', value: 'measure_play', type: 'boolean' },
        // { text: 'Aloitusaika', value: 'starttime', type: 'number' },
        // { text: 'Päättymisaika', value: 'endtime', type: 'number' },
        { text: 'Korkea syöttö', value: 'pitch.tall_pitch', type: 'boolean' },
        { text: 'Väärän tyyppi', value: 'pitch.wrong_type', type: 'string' },
        // { text: 'Base ID', value: 'map_base_id', type: 'number' },
        // { text: 'Ulkopelisuorittaja ID', value: 'play.play_player.id', type: 'number' },
        { text: 'Ulkopelisuorittaja', value: 'play.play_player.name', type: 'string' },
        // { text: 'Lyöntialue ID', value: 'pitch_map_base_id', type: 'string' },
        { text: 'Syöttötuomari', value: 'pitching_referee_name', type: 'string' },
        { text: 'Merkin tyyppi', value: 'mark_type', type: 'string' },
        { text: 'Merkattu laiton', value: 'marked_laiton', type: 'boolean' },
        // { text: 'Liiga ID', value: 'league_id', type: 'number' },
        // { text: 'Kauden ID', value: 'season_id', type: 'number' },
        // { text: 'Kauden vuosi', value: 'season_year', type: 'number' },
        // { text: 'Peli valmis', value: 'play_done', type: 'boolean' },
        // { text: 'Stream URL', value: 'stream_url', type: 'string' }

        { text: 'Nypyt', value: 'nypyt', type: 'number' },
        { text: 'Ulkopelikuvio', value: 'outfield_formation', type: 'string' },
        // outs
        { text: 'Palot', value: 'outs', type: 'number' },
        // vvo
        { text: 'Vedottu oikea syöttö', value: 'vvo', type: 'number' },
        // was_wrong
        { text: 'Väärä syöttö', value: 'was_wrong', type: 'boolean' },
        { text: 'Läpilyönti', value: 'lapilyonti', type: 'boolean' },
  ],
      possibleGroupBys: [
        { text: 'Ulkopelijoukkue', value: 'fielding_team_id', type: 'number' },
        { text: 'Sisäpelijoukkue', value: 'hitting_team_id', type: 'number', final_type: 'string' },
        { text: 'Kotijoukkue', value: 'home_team_id', type: 'number', final_type: 'string' },
        { text: 'Vierasjoukkue', value: 'away_team_id', type: 'number', final_type: 'string' },
        { text: 'Tilanne', value: 'bases_state', type: 'string' },
        { text: 'Lyöjä', value: 'hitter_name', type: 'string' },
        { text: 'Kärkijetenijä', value: 'karkirunner_name', type: 'string' },

        // { text: 'Event ID', value: 'event_id', type: 'string' },
        { text: 'Laittoman jälkeinen turha', value: 'after_marked_laiton', type: 'boolean' },
        // { text: 'Away Hitter Num', value: 'away_hitter_num', type: 'number' },
        // { text: 'Bases First ID', value: 'bases.first.id', type: 'number' },
        // { text: 'Bases First Name', value: 'bases.first.name', type: 'string' },
        // { text: 'Bases Home ID', value: 'bases.home.id', type: 'number' },
        // { text: 'Bases Home Name', value: 'bases.home.name', type: 'string' },
        // { text: 'Bases Second ID', value: 'bases.second.id', type: 'number' },
        // { text: 'Bases Second Name', value: 'bases.second.name', type: 'string' },
        // { text: 'Bases Third ID', value: 'bases.third.id', type: 'null' },
        // { text: 'Bases Third Name', value: 'bases.third.name', type: 'null' },
        // { text: 'Base Changes First To Second', value: 'base_changes.first_to_second', type: 'null' },
        // { text: 'Base Changes Home To First', value: 'base_changes.home_to_first', type: 'null' },
        // { text: 'Base Changes Second To Third', value: 'base_changes.second_to_third', type: 'string' },
        // { text: 'Base Changes Third To Home', value: 'base_changes.third_to_home', type: 'null' },
        // { text: 'Date', value: 'date', type: 'number' },
        // { text: 'Endtime', value: 'endtime', type: 'number' },
        { text: 'Peli', value: 'game_id', type: 'string', final_type: 'string' },
        { text: 'Vuoropari', value: 'game_phase.inning', type: 'number' },
        { text: 'Jakso', value: 'game_phase.jakso', type: 'number' },
        { text: 'Tasoittava vuoro', value: 'game_phase.lopettava', type: 'boolean' },
        // { text: 'Hitter ID', value: 'hitter_id', type: 'number'possibleColumns },
        // { text: 'Hitter Number', value: 'hitter_number', type: 'number' },
        { text: 'Lyöntipuoli', value: 'hitter_side', type: 'string' },
        // { text: 'Hitting', value: 'hitting', type: 'string' },
        { text: 'Lyönnin suunta', value: 'hit_direction', type: 'string' },
        // { text: 'Hit Map Coordinates X', value: 'hit_map_coordinates.x', type: 'number' },
        // { text: 'Hit Map Coordinates Y', value: 'hit_map_coordinates.y', type: 'number' },
        { text: 'Lyönti nro.', value: 'hit_number', type: 'number' },
        { text: 'Tulos', value: 'hit_outcome', type: 'string' },
        { text: 'Lyönnin tyyppi', value: 'hit_type', type: 'string' },
        // { text: 'Home Hitter Num', value: 'home_hitter_num', type: 'number' },
        // { text: 'Joker Hitting', value: 'joker_hitting', type: 'boolean' },
        // { text: 'Kärkijuoksija ID', value: 'karkirunner_id', type: 'number' },
        { text: 'Stadion', value: 'stadion_id', type: 'number', final_type: 'string' },
        // { text: 'Lyöntivuoro', value: 'plate_appearance_id', type: 'string' },
        // { text: 'Syöttökartta X', value: 'pitch.wrong_map_coordinates.x', type: 'number' },
        // { text: 'Syöttökartta Y', value: 'pitch.wrong_map_coordinates.y', type: 'number' },
        // { text: 'Heitto tapahtui', value: 'play.has_play_time', type: 'boolean' },
        // { text: 'Lyönnin matka kentältä', value: 'play.movement_distances.from_home_hit', type: 'number' },
        // { text: 'Lyönnin matka haltuunotosta', value: 'play.movement_distances.from_home_possession', type: 'number' },
        // { text: 'Heitto tapahtui', value: 'play.play_video_times.throw_goes', type: 'number' },
        // { text: 'Pallon haltuunotto', value: 'play.play_video_times.possession', type: 'number' },
        // { text: 'Juoksun ID', value: 'run.run_id', type: 'number' },
        // { text: 'Lähtöaika', value: 'run.run_times.lahto', type: 'number' },
        // { text: 'Etenijä pesässä', value: 'run.run_video_times.on_base', type: 'number' },
        { text: 'Up-suorituksen tulos', value: 'play.play_outcome', type: 'string' },
        { text: 'Kärkilyönnit', value: 'karkilyonnit', type: 'number' },
        // { text: 'Edellinen lyönti', value: 'previous_hit_id', type: 'string' },
        // { text: 'Heiton kovuus', value: 'play.throw_calculated_speed', type: 'number' },
        // { text: 'Lähtönopeus', value: 'run.measured_from_hit', type: 'boolean' },
        // { text: 'Pelin mittaus', value: 'measure_play', type: 'boolean' },
        // { text: 'Aloitusaika', value: 'starttime', type: 'number' },
        // { text: 'Päättymisaika', value: 'endtime', type: 'number' },
        { text: 'Korkea syöttö', value: 'pitch.tall_pitch', type: 'boolean' },
        { text: 'Väärän tyyppi', value: 'pitch.wrong_type', type: 'string' },
        // { text: 'Base ID', value: 'map_base_id', type: 'number' },
        // { text: 'Ulkopelisuorittaja ID', value: 'play.play_player.id', type: 'number' },
        { text: 'Ulkopelisuorittaja', value: 'play.play_player.name', type: 'string' },
        // { text: 'Lyöntialue ID', value: 'pitch_map_base_id', type: 'string' },
        { text: 'Syöttötuomari', value: 'pitching_referee_name', type: 'string' },
        { text: 'Merkin tyyppi', value: 'mark_type', type: 'string' },
        { text: 'Merkattu laiton', value: 'marked_laiton', type: 'boolean' },
        // { text: 'Liiga ID', value: 'league_id', type: 'number' },
        // { text: 'Kauden ID', value: 'season_id', type: 'number' },
        // { text: 'Kauden vuosi', value: 'season_year', type: 'number' },
        // { text: 'Peli valmis', value: 'play_done', type: 'boolean' },
        // { text: 'Stream URL', value: 'stream_url', type: 'string' }

        { text: 'Nypyt', value: 'nypyt', type: 'number' },
        { text: 'Ulkopelikuvio', value: 'outfield_formation', type: 'string' },
        // outs
        { text: 'Palot', value: 'outs', type: 'number' },
        // vvo
        { text: 'Vedottu oikea syöttö', value: 'vvo', type: 'number' },
        // was_wrong
        { text: 'Väärä syöttö', value: 'was_wrong', type: 'boolean' },
        { text: 'Läpilyönti', value: 'lapilyonti', type: 'boolean' },
      ]
    };
  }
};
